/**
 * Central registry of React Query cache keys.
 *
 * Keeping them in one object means an invalidation can never miss a key
 * because it was spelled differently at the call site.
 */
import type { JudgmentFilters } from '@/types/api'
import type { SearchQuery } from '@/lib/apiClient'

export const queryKeys = {
  judgments: {
    all: ['judgments'] as const,
    search: (query: SearchQuery) => ['judgments', 'search', query] as const,
    detail: (id: number) => ['judgments', 'detail', id] as const,
    facets: (filters: JudgmentFilters) => ['judgments', 'facets', filters] as const,
    stats: () => ['judgments', 'stats'] as const,
    suggest: (prefix: string) => ['judgments', 'suggest', prefix] as const,
  },
  jobs: {
    all: ['jobs'] as const,
    list: () => ['jobs', 'list'] as const,
    detail: (id: number) => ['jobs', 'detail', id] as const,
    importable: () => ['jobs', 'importable'] as const,
  },
  captures: {
    all: ['captures'] as const,
    list: () => ['captures', 'list'] as const,
    page: (page: number, pageSize: number) =>
      ['captures', 'page', page, pageSize] as const,
  },
} as const
